import { useQuery } from '@tanstack/react-query'
import { fastIdSearch, FastIdSearchResult } from 'api/fastIdSearch'

const fastIdSearchKey = (search: string, limit: number) => [
  'commandPalette',
  'fastIdSearch',
  search,
  limit,
]

export function useFastIdSearchQuery({
  search,
  limit = 10,
  enabled = true,
}: {
  search: string
  limit?: number
  enabled?: boolean
}) {
  return useQuery<FastIdSearchResult>({
    queryKey: fastIdSearchKey(search, limit),
    queryFn: () => fastIdSearch(search, limit),
    enabled: enabled && search.trim().length > 0,
  })
}
